/**
 * @generated SignedSource<<47a67c122c6700b5d7d97a3834405bb2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PaymentMethodPixValue_charge$data = {
  readonly company: {
    readonly nameFriendly: string | null | undefined;
  } | null | undefined;
  readonly paymentSubscriptionInstallment: {
    readonly value: number | null | undefined;
  } | null | undefined;
  readonly value: number | null | undefined;
  readonly " $fragmentType": "PaymentMethodPixValue_charge";
};
export type PaymentMethodPixValue_charge$key = {
  readonly " $data"?: PaymentMethodPixValue_charge$data;
  readonly " $fragmentSpreads": FragmentRefs<"PaymentMethodPixValue_charge">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PaymentMethodPixValue_charge",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Company",
      "kind": "LinkedField",
      "name": "company",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "nameFriendly",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "PaymentSubscriptionInstallment",
      "kind": "LinkedField",
      "name": "paymentSubscriptionInstallment",
      "plural": false,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "Charge",
  "abstractKey": null
};
})();

(node as any).hash = "acb824538ca0414ae0598583f0ffb1ca";

export default node;
